import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import ClaimFormatterFunctions from '../Claims/ClaimFormatters';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
const { ExportCSVButton } = CSVExport;


// Column headers for the claims grid
const SRColumns = [
  { dataField: 'id', hidden:true, text: 'id', headerStyle: (colum, colIndex) => {
    return { width: '50px', textAlign: 'left' };
  } },
  { dataField: 'recipient', text: 'Recipient', classes:'text-primary', sort: true, textAlign: 'left'},
   { dataField: 'ageInDays', text: 'ageInDays', classes:'text-primary', sort: true, textAlign: 'left'},
   { dataField: 'dateReceived', text: 'dateReceived',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {
    return { width: '130px', textAlign: 'center' };
  }  },
  { dataField: 'guestPickupDate', text: 'Pick-up Date',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {
    return { width: '130px', textAlign: 'center' };
  }  },

  { dataField: 'storageLocation', text: 'Storage location', classes:'text-primary', sort: true, textAlign: 'left'},
  { dataField: 'barcodeValue', text: 'Tracking#',formatter:trimBarcode,headerStyle:{width:'300px'}, classes:'text-primary', sort: true, textAlign: 'left'},
  { dataField: 'parcelGroupTotalCount', text: 'Group Parcel Count', classes:'text-primary', sort: true, textAlign: 'left'},
  { dataField: 'status', text: 'Stage', formatter:statusFormatter, filterable:true, sort: true, textAlign: 'left' },
 
  { dataField: 'roomNumber', text: 'Room',sort: true,classes:'text-primary', },
  { dataField: 'reservationId', text: 'Reservation#',sort: true,classes:'text-primary', },
  { dataField: 'parcelRef', text: 'Internal Reference',sort: true,classes:'text-primary', },
  { dataField: 'arrivalDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Guest Arrival Dt.'},  
  { dataField: 'serviceFee',sort: true,formatter: LostItemFunctions.formatMoney, textAlign: 'right',align: 'center', text: 'Handling Fee($)' },  
 
  { dataField: 'isPaid',sort: true,formatter:paidFormatter, textAlign: 'center',align: 'center', text: 'Paid' },
  { dataField: 'paidAt',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Paid On'},  
  { dataField: 'paidAmount',sort: true,formatter: LostItemFunctions.formatMoney, textAlign: 'right',align: 'center', text: 'Paid Amount' },  
];
const defaultSorted = [{
    dataField: 'dateReceived',
    order: 'desc'
  }];
  
  function paidFormatter(cell, row){
    if (cell === true){
      return (<h6 >PAID</h6>);
    }else{
      return (<h6 >UNPAID</h6>);
    }
  }

function statusFormatter(cell,row){
    if (row.statusCd==='I'){
      return "IN STORAGE";
    }else if (row.statusCd==='GP'){
      return "GUEST PICKUP";
    }else if (row.statusCd==='SB'){
      return "SENT BACK";
    }else if (row.statusCd==='A'){
      return "ARCHIVE";
    }
  
  
  }  
  
 function trimBarcode(cell,row){
   if (cell){
     try{
       let length = 30
      if (cell.length > length){
        return cell.substring(0,length) + '...';
      }else{
        return cell;
      }
     }catch(e){
       return '';
     }
   }else{
     return '';
   }
 }

  class PTAgedReport extends Component {
    constructor(props) {
      super(props);
        this.state = { SRItems: []}
        this._input = null;
    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadSRItemData();
       
     
       }

       loadSRItemData = () =>{
        try {
          axios.get(`${SERVER_URL}/Reports/AgedParcelTracking`,{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
           }).then((res)=>{
             
             if (res.status === 401) {
               //place your reentry code
               console.log("Error" + res.status);
              
              }
     
             const SRItems = res.data;
         
           

             this.setState({
                SRItems : SRItems,
            
              });


            });
        }catch(e){

        }
    }


    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        
      }
      renderLostItemGrid=()=>{
        return (
    
          <div >
           
           
           {this.renderToast()}
           {this.state.lostItems === null && <p>Loading Report...</p>}
            <ToolkitProvider 
            bootstrap4
              keyField='id' 
              data={ this.state.SRItems } 
              columns={ SRColumns } 
              exportCSV
              defaultSorted={defaultSorted}
             
              >
              {
        props => (
          <div>
        
           <ExportCSVButton { ...props.csvProps }>Export CSV for Printing</ExportCSVButton>
           
        <hr />
            <BootstrapTable
            
              striped
                condensed
             
              
              { ...props.baseProps }
             
            />
          </div>
        )
      }</ToolkitProvider>
    
          </div>
    
    
        )
    
        
      }
    

    render(){

        return(

            <div className="text-center" ref={c => (this._input = c)}> <h5> Parcel Detail Report </h5>
            <h6>{LostItemFunctions.formatDate(Date())}</h6>
              {this.renderToast()}
              {this.renderLostItemGrid()}
            
            </div>

        )



    }
}


export default withRouter(PTAgedReport);